export default {
  contractorsConnectionList: [],
  setPreferredContractorsCategory: [],
  tradeUserConnectionList: [],
  preferredContractorsList: [],
  contractorsCategoryList: [],
  clientRaiseEstimate: null,
};
